<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router';
    import fetchData from '../api.js';
    import { systemUrl } from '../api.js';
	import { silentPrint }  from '../base/printer.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Shipment from '../pages/Shipment.svelte';
    import Status from '../components/Status.svelte';
    import { createEventDispatcher } from 'svelte';
    

    export let orders = []

    let ordersList = orders;
    let statuses = [];
    let statusShow = false;


    const print_url = systemUrl + '/label?token=' + $UserStore.data + "&order_ids=";    


    const dispatch = createEventDispatcher();




    $: ordersSelectedIds = orders
        .filter(order => order.enabled) 
        .map(order => order.order_id);
    $: ordersSelectedIdsPrints = orders
        .filter(order => order.enabled && order.shipment_id !== null) 
        .map(order => order.order_id);

        
    const BulkShipment = () => {
        push('/shipments/' + ordersSelectedIds.join(","))
    }

    function printSlip() {

        const printIds = orders
            .filter(order => order.enabled)
            .map(order => order.order_id);

        const slip_url = systemUrl + '/print_packingslip?token=' + $UserStore.data + "&order_id=";
        const printWindow = window.open(slip_url + printIds.join(",") , '_blank');

    }

    const BulkPrint = () => {

        // const printIds = orders.filter(order => order.enabled).map(order => order.order_id);
        // let link = print_url + printIds.join(",");
        // if (shippingo=="1") {
        //     link += "&shippingo=1";
        // }
        // window.open(link, '_blank');


        const printIds = orders
            .filter(order => order.enabled && order.shipment_id !== null)
            .map(order => order.order_id);

        if (printIds.length === 0) {
            alert("ניתן להדפיס רק הזמנות שכבר הונפק להם שטר מטען. יש להנפיק שטר מטען ורק לאחר מכן להדפיס");
        } else {
            let link = print_url + printIds.join(",");
            if (shippingo === "1") {
                link += "&shippingo=1";
            }
            window.open(link, '_blank');
        }

    }

    const BulkPacking = () => {

        const url = new URL(window.location);
        const hashParams = new URLSearchParams(url.hash.split('?')[1]);
        const tab = hashParams.get('tab');

        push('/shipments/' + ordersSelectedIds.join(",") + "/likut/"+tab)
    }

    const openStatusBox = (index) => {
        
        statusShow = true;
        statuses = orders[index].shipments_status_list

    }

    const closeStatus = async(event) => {
        statusShow = !statusShow;
    }

    let allChecked = false;

    function checkBoxAll() {
        // Toggle the state of `allChecked`
        allChecked = !allChecked;

        // Set each `enabled` property to match the `allChecked` state
        for (const key in orders) {
            orders[key].enabled = allChecked;
        }

    }


    function dateOlderThan(shipment_id,dateString,days) { 
        
        if (shipment_id!=null) {

            return false;

        }

        if (typeof $UserStore.erp !== 'undefined' && $UserStore.erp==1) {



            //console.log(dateString,days)
            const itemDate = new Date(dateString);
            const DaysAgo = new Date();
            DaysAgo.setDate(DaysAgo.getDate() - days);

            return itemDate < DaysAgo;

        } else {
            return false;
        }
    }

    async function changeStatus(order_id,status,index) {

        if(!confirm('האם ברצונך להסיר את הזמנה זו מהרשימה?')) {
            return;
        }

        let postData = {}; 
        postData.action = 'crm_change_status';   
        postData.token = $UserStore.data;  
        postData.status = status
        postData.order_id = order_id

        let response = await fetchData(postData);
        if (response.success) {       
            orders.slice(0,index)
            orders = [...orders]
        }

    }

    

    
</script>
<Status {statuses} {statusShow} on:close={closeStatus} />
{#if ordersSelectedIds.length}
<div class="orders-bulk-con">
    <div class="button" on:click={()=> BulkShipment() }>{$_('orders.bulk_shipment')}</div>
    {#if ordersSelectedIdsPrints.length}
    <div class="button" on:click={()=> BulkPrint() }>{$_('orders.bulk_print')}</div>
    {/if}
    {#if $UserStore.settings?.shipping_settings?.enable_scanning_products == "1"}
    <div class="button" on:click={()=> BulkPacking() }>{$_('orders.bulk_packing')}</div>
    {/if}
    {#if $UserStore?.erp == 1}
    <div class="button" on:click={()=>{ printSlip(); }}>{$_('shipment.create_slip')}</div>
    {/if}
</div>
{/if}
<div class="table table-shipments orders">
    <div class="head">
        <div class="input_con radio checkbox">            
            <input id="id_all" type="checkbox" bind:checked={allChecked} on:click={checkBoxAll}>       
            <label for="id_all"><span></span></label>     
        </div>
        <div>{$_('orders.date')}</div>
        <div>{$_('orders.shipment_id')}</div>
        <div>{$_('orders.order_name')}</div>
        <div>{$_('orders.shipping_customer_details')}</div>
        <div>{$_('orders.type')}</div>
        {#if $UserStore?.erp==1}
        <div>{$_('orders.order_status')}</div>
        {/if}        
        
        <!-- <div>{$_('orders.address')}</div> -->
        <div>{$_('orders.phone')}</div>        
        <div>{$_('orders.shipping_method')}</div>
        <div>{$_('orders.shipment_status')}</div>        
        {#if $UserStore?.erp==1}
        <div>{$_('orders.external_id')}</div>
        <div>{$_('orders.print_date')}</div>
        {/if}
        <div></div>
    </div>
    {#each orders as item,index}
    <div class="content {dateOlderThan(item.shipment_id,item.current_date,5) ? 'marked' : ''} {item.print_date ? 'has-print-date' : ''}">
        <div class="input_con radio checkbox">            
            <input id="enabled{index}" type="checkbox" bind:value={item.enabled} bind:checked={item.enabled}>       
            <label for="enabled{index}"><span></span></label>     
        </div>
        <div>
            <div class="mobile">{$_('orders.date')}</div>
            <div class="date_time"> 
                <div>{item.current_time }</div>
                <div class="date">{item.current_date }</div>                            
            </div>
        </div>
        <div class="shipment_id">
            <div class="mobile">{$_('orders.shipment_id')}</div>
            <div>
                {#if item.shipment_id!=null}
                <a href="{print_url}{item.order_id}" target="_blank">
                    <i class="fa-solid fa-print red-color"></i> 
                    <span>{item.shipment_id}</span>
                </a>
                {:else}
                <i class="fa-solid fa-circle-exclamation"></i>
                {/if}
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.order_name')}</div>
            <div>{item.order_name}</div>
        </div> 
        <div>
            <div class="mobile">{$_('orders.shipping_customer_details')}</div>            
            <div class="address text-start">
                <div><strong>{$_('orders.customer')}:</strong> {item.shipping_firstname}</div>
                <div><strong>{$_('orders.city')}:</strong> {item.shipping_city}</div>
                <div><strong>{$_('orders.address')}:</strong> {item.shipping_address}</div>
            </div>
        </div>       
        <div>
            <div class="mobile">{$_('orders.type')}</div>
            <div class="flex">{$_('orders.type' + item.type)}</div>
        </div>   
        {#if $UserStore?.erp==1}        
        <div>
            <div class="mobile">{$_('orders.order_status')}</div>
            <div class="flex">{item.order_status}</div>
        </div> 
        {/if}
        <!-- <div>
            <div class="mobile">{$_('orders.address')}</div>
            <div class="address">
                <div>{item.shipping_city}</div>
                <div>{item.shipping_address}</div>
            </div>
        </div> -->
        <div>
            <div class="mobile">{$_('orders.phone')}</div>
            <div class="text-start">
                <a class="phone" href="tel:{item.shipping_phone}"><i class="fa-solid fa-phone"></i></a>
                <a class="phone whatsapp" href="https://wa.me/{item.shipping_phone}"><i class="fa-brands fa-whatsapp"></i></a>
                <span class="ltr">{item.shipping_phone}</span>
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.shipping_method')}</div>
            <div>
                <span class="ltr">{#if item.shipping_method!=null}{item.shipping_method}{/if}</span>
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.shipment_status')}</div>
            <div>
                <div class="text-[12px]">
                    {#if Object.keys(item.shipment_status).length}
                        <div>{item.shipment_status.date}</div>
                        <div>{item.shipment_status.status}</div> 
                        <div on:click={()=>openStatusBox(index)} class="bg-red-100 hover:bg-red-300 text-black rounded-[15px] p-1 cursor-pointer">{$_('orders.view_all_status')}</div>                       
                    {/if}
                </div>
            </div>
        </div>
        
        {#if $UserStore?.erp==1}
        <div>
            <div class="mobile">{$_('orders.verifone')}</div>
            <div>
                <span class="ltr">{#if item.external_id!=null}{item.external_id}{:else}<i class="fa-solid fa-circle-exclamation"></i>{/if}</span>
            </div>
        </div>
        <div class="size-12">
            <div class="mobile">{$_('orders.print_date')}</div>
            <div>
                {#if item.print_date}
                    <span class="ltr">{item.print_date}</span>
                {/if}
                <!-- <div class="pbutton" on:click={()=>  { sendPrintJob(item.order_id,2); }}>הדפסה</div> -->
            </div>
        </div>   
        {/if}     
        <div>
            <div class="small_button" on:click={()=> push('/shipment/' + item.order_id)}>
                {#if item.shipment_id}
                <span>{$_('orders.edit_shipment')}</span>
                <i class="fa-solid fa-pen-to-square"></i>
                {:else}
                <span>{$_('orders.send_shipment')}</span>
                <i class="fa-solid fa-chevron-left"></i>
                {/if}
            </div>
            <!-- <div class="small_button" on:click={()=> changeStatus(item.order_id,4,index)}>
                <span>{$_('orders.delete')}</span>
                <i class="fa-solid fa-trash"></i>
            </div> -->
            
        </div>
    </div>
    {/each}
</div>

<style>
.size-12 {
    font-size:12px;
}

.table-shipments .content > div{
    vertical-align: middle;;
}
.table-shipments .content .red-color {
    color: var(--theme-one-color);
}
.table-shipments .content > div:nth-child(6) {
    max-width:150px;
}
.table-shipments .content .date_time {
    display: flex;
    flex-direction: column;
}
.date_time .date {
    font-size: 11px;;
}
a.phone { 
    display: inline-block;
    padding:0 2px;
    font-size: 14px;; 
    /* color: #050a30;   */
}
a.phone.whatsapp {
    text-decoration: none;
    color: green;  
    font-size: 17px;;  
}
.shipment_id {
   /* color: #050a30;    */
   cursor: pointer;
}
.shipment_id span {
    display: inline-block;
    padding:0 5px;
    /* text-decoration: underline; */
}

@media screen and (max-width:600px) {
    .table-shipments .content > div:nth-child(6) {
        max-width:none;
    }
    .shipment_id span {
        padding:0;
    }

    .address {
        text-align: left;
    }
}

</style>